export default {
	id: "",
};
